export function Table({ columns, data, loading = false, onRowClick, isDarkMode = false, sortBy = null, sortOrder = 'asc', onSort = null }) {
  if (loading) {
    return <div className={`text-center py-8 ${isDarkMode ? 'text-slate-400' : 'text-gray-600'}`}>Loading...</div>
  }

  if (!data || data.length === 0) {
    return <div className={`text-center py-8 ${isDarkMode ? 'text-slate-400' : 'text-sfp-darkgray'}`}>No data available</div>
  }

  const stickyThClass = (col) => {
    if (col.sticky === 'right') return `sticky right-0 z-10 ${isDarkMode ? 'bg-slate-700' : 'bg-gray-100'}`
    if (col.sticky === 'left')  return `sticky left-0 z-10 ${isDarkMode ? 'bg-slate-700' : 'bg-gray-100'}`
    return ''
  }

  const stickyTdClass = (col, idx) => {
    const base = idx % 2 === 0
      ? isDarkMode ? 'bg-slate-800' : 'bg-sfp-lightgray'
      : isDarkMode ? 'bg-slate-900' : 'bg-white'
    if (col.sticky === 'right') return `sticky right-0 z-10 ${base} shadow-[-4px_0_6px_-1px_rgba(0,0,0,0.08)]`
    if (col.sticky === 'left')  return `sticky left-0 z-10 ${base} shadow-[4px_0_6px_-1px_rgba(0,0,0,0.08)]`
    return ''
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-max w-full border-collapse">
        <thead>
          <tr className={`transition-colors duration-300 ${
            isDarkMode
              ? 'bg-slate-700 text-slate-100'
              : 'bg-gray-100 text-gray-700'
          } font-semibold text-xs uppercase tracking-wider`}>
            {columns.map((col) => {
              const sortKey = col.sortKey || col.key
              const isSorted = sortBy === sortKey
              const isClickable = col.sortable && onSort
              return (
                <th
                  key={col.key}
                  className={`px-4 py-3 text-left whitespace-nowrap select-none ${isClickable ? 'cursor-pointer hover:bg-black/10' : ''} ${stickyThClass(col)}`}
                  onClick={isClickable ? () => onSort(sortKey) : undefined}
                >
                  <span className="inline-flex items-center gap-1">
                    {col.label}
                    {col.sortable && (
                      <span className="text-xs opacity-50">
                        {isSorted ? (sortOrder === 'asc' ? ' ▲' : ' ▼') : ' ⇅'}
                      </span>
                    )}
                  </span>
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr
              key={idx}
              className={`transition-colors duration-300 ${
                idx % 2 === 0
                  ? isDarkMode ? 'bg-slate-800' : 'bg-sfp-lightgray'
                  : isDarkMode ? 'bg-slate-750' : 'bg-white'
              } ${onRowClick ? (isDarkMode ? 'cursor-pointer hover:bg-slate-700' : 'cursor-pointer hover:bg-orange-50') : ''} border-b ${isDarkMode ? 'border-slate-700' : 'border-sfp-border'}`}
              onClick={() => onRowClick?.(row)}
            >
              {columns.map((col) => (
                <td key={col.key} className={`px-4 py-3 ${isDarkMode ? 'text-slate-300' : 'text-sfp-darkgray'} ${stickyTdClass(col, idx)}`}>
                  {col.render ? col.render(row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
